import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"contact\"><div class=\"contact__body\"><p class=\"contact__mail\">hebitsukai.hebiport@gmail.com</p><div class=\"contact__txt\"><p>イラスト制作のご相談・ご依頼は<br class=\"u-sp-only\">上記のメールアドレスまで<br class=\"u-sp-only\">お気軽にお問い合わせください。<br>2営業日以内にご返信させていただきます。</p></div></div></div>", 1)
const _hoisted_2 = { class: "u-pc-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_BackBtn = _resolveComponent("BackBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { title: "CONTACT" }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackBtn, {
        url: "/",
        text: "HOME"
      })
    ])
  ], 64))
}